var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"testAnnal-all"},[_c('edp-header',{attrs:{"noSearch":"true"}}),_c('div',{staticClass:"testAnnal-content"},[(_vm.pageShow)?_c('div',{staticClass:"testAnnal"},[_c('img',{attrs:{"src":require("@/src/assets/test/testAnn.jpg"),"alt":""}})]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }